import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import HeroSection from "./components/HeroSection";
import IntroSection from "./components/IntroSection";
import LegendsSection from "./components/LegendsSection";
import GallerySection from "./components/GallerySection";
import ComingSoonSection from "./components/ComingSoonSection";
import FilmGrain from "./components/FilmGrain";

function App() {
  useEffect(() => {
    // Initialize smooth scrolling
    const lenis = new Lenis({
      duration: 1.5,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-container">
      <FilmGrain />
      <HeroSection />
      <IntroSection />
      <LegendsSection />
      <GallerySection />
      <ComingSoonSection />
    </div>
  );
}

export default App;
